import { Box, Flex, Switch } from "@chakra-ui/react";
import time from "src/utils/time";
import { H3, BodyText2 } from "src/atoms/typography";
import IconAsButton from "src/components/IconAsButton";
import ListButton from "src/components/ListButton/ListButton";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as AddIcon } from "../icons/add.svg";
import { ReactComponent as WarningIcon } from "../icons/warning-small.svg";

export default function SchedulerCreator({
  t,
  isEnabled,
  onToggle,
  openNotifications,
  openSchedule,
  activeTasks,
  scheduler,
  numberOfDevices,
  notifyAllDevices
}) {
  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="center" columnGap="12px">
        <Box>
          <H3>{t("scheduler.startAutomatically.heading")}</H3>
          <BodyText2>{t("scheduler.startAutomatically.text")}</BodyText2>
        </Box>
        <Switch isChecked={isEnabled} onChange={onToggle} />
      </Flex>
      {isEnabled && (
        <Flex mt="8px" alignItems="center">
          <SvgContainer icon={WarningIcon} mr="8px" />
          <BodyText2 color="command-tint2">
            {t("scheduler.keepStationOpen")}
          </BodyText2>
        </Flex>
      )}
      <Flex
        mt="24px"
        flexDirection="column"
        gap="24px"
        transition="all 0.3s"
        {...(!isEnabled && {
          opacity: 0.4,
          pointerEvents: "none"
        })}
      >
        <Box width="50%">
          <ListButton
            onClick={openNotifications}
            labelKey={t("notifications.heading")}
            additionalText={
              notifyAllDevices
                ? t("scheduler.notifications.allDevices")
                : t("plurals:devicesCount", {
                    count: numberOfDevices || 0
                  })
            }
          />
        </Box>

        <Box width="50%">
          <Flex alignItems="center" mb="16px">
            <H3 mr="10px">{t("scheduler.schedule.heading")}</H3>
            <IconAsButton
              fill="primary"
              icon={AddIcon}
              onClick={() => openSchedule()}
              hoverBg="primaryLight"
              activeBg="primaryLight2"
            />
          </Flex>
          {activeTasks.map((task) => {
            const startDateObj = time().set({
              hour: task.startTime.hour,
              minute: task.startTime.minute
            });
            const endDateObj = time().set({
              hour: task.endTime.hour,
              minute: task.endTime.minute
            });
            const daysAdjective = scheduler?.getDaysAdjective({
              days: task.days,
              t,
              addSeparation: true,
              short: task.days.length > 1
            });
            return (
              <ListButton
                labelKey={daysAdjective}
                mb="16px"
                key={task.id}
                captionProps={{ maxWidth: "120px" }}
                onClick={() => openSchedule(task)}
                additionalText={`${startDateObj.format(
                  "HH:mm"
                )} - ${endDateObj.format("HH:mm")}`}
              />
            );
          })}
        </Box>
      </Flex>
    </Box>
  );
}
